export type Video = {
  title: string;
  lengthInSeconds: number;
  link: string;
  description: string;
  videoNumber?: number;
};

export const allVideosDE: Video[] = [
  {
    title: 'Zählen von Vorkommen',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=jYLq0G3I-Fw',
    description:
      'Die Funktion zum Zählen von Werten innerhalb von Beobachtungen ermöglicht es dir, eine Variable zu erstellen, die das Vorkommen bestimmter Werte in einer definierten Menge von Variablen zählt. Zum Beispiel kannst du mit dieser Funktion ermitteln, wie viele verschiedene Magazine eine Person liest.',
  },
  {
    title: 'Variablen sortieren',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=nGn76s5OxcU',
    description: 'In diesem Tutorial schauen wir uns genauer an, wie du Variablen sortierst.',
  },
  {
    title: 'Variablen umkodieren',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=Mb9zwpfEHoo',
    description:
      "In diesem Tutorial zeigen wir dir, wie du die Funktion 'Variablen umkodieren' verwendest.",
  },
  {
    title: 'Sortieren und Filtern von Variablenbeschreibungen',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=c2zW7iIM8hA',
    description:
      'Diese Präsentation zeigt dir, wie du Variablenbeschreibungen sortieren und auswählen kannst.',
  },
  {
    title: 'Daten im Dateneditor beschreiben',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=lVivjcAcZF8',
    description:
      'Wir zeigen dir, wie du Variableneigenschaften in der Variablenansicht des Dateneditors definierst.',
  },
  {
    title: 'Neue Variablen erstellen',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=A7fwVszEAf8',
    description:
      'Lerne, wie du mit PS IMAGO PRO neue Variablen berechnest, z. B. durch mathematische Operationen oder Textverarbeitung.',
  },
  {
    title: 'Datums- und Zeit-Assistent',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=c-pxi4ijAqo',
    description: 'Hier erkunden wir den Assistenten für Datums- und Zeitberechnungen.',
  },
  {
    title: 'Variableneigenschaften kopieren',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=X86QGdaM1sQ',
    description:
      'Das Kopieren von Variableneigenschaften ist wichtig für eine effiziente Datenvorbereitung. Erfahre, wie du das in PS IMAGO PRO machst.',
  },
  {
    title: 'Visuelle Kategorisierung',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=xOemuIldkvI',
    description:
      'Dieses Tutorial behandelt, wie du kontinuierliche Variablen in Kategorien umwandelst oder die Anzahl der Kategorien ordinaler Variablen reduzierst.',
  },
  {
    title: 'Variablen hinzufügen',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=VVEohaKXzSY',
    description: 'Lerne, wie du zusätzliche Variablen zu deinem Datensatz hinzufügen kannst.',
  },
  {
    title: 'Kommentare zu Variablen hinzufügen',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=0a456Sro6bA',
    description:
      'Füge Kommentare und Benutzerattribute zu Variablen hinzu, um deine Daten besser zu dokumentieren.',
  },
  {
    title: 'Globale Bezeichnungen berechnen',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=Q5kRnST6skg',
    description:
      'Diese Funktion hilft dir, globale Werte für dein gesamtes Dataset zu berechnen, z. B. jährliche Verkaufszahlen.',
  },
  {
    title: 'Automatische Rekodierung',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=wVQ6WhcHp_M',
    description:
      'Automatisiere das Umkodieren von Zeichen- oder numerischen Variablen in fortlaufende Ganzzahlen.',
  },
  {
    title: 'Text aufteilen',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=Z6u5krT_gwE',
    description: 'Teile Textwerte in mehrere neue Variablen auf, um deine Daten zu strukturieren.',
  },
  {
    title: 'Seltene Kategorien umkodieren',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=MWfl-hh9G3k',
    description:
      'Diese Funktion erlaubt es dir, seltene Kategorien in deinen Daten zusammenzufassen, um Analysen zu erleichtern.',
  },
  {
    title: 'Zeichenfolgen zählen',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=XxArjaDIifY',
    description: 'Zähle das Vorkommen bestimmter Zeichenfolgen in einer Textvariablen.',
  },
  {
    title: 'Invertierte Kodierung',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=jYaGP7ORXKo',
    description:
      'Drehe die Kodierung von Variablen um, um eine bessere Vergleichbarkeit in Analysen zu ermöglichen.',
  },
  {
    title: 'Kategorien monoton umkodieren',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=gOm5hfbOPos',
    description:
      'Ordne Kategorien einer Variablen so um, dass die häufigste Kategorie zuerst erscheint.',
  },
  {
    title: 'Normalisierung von Variablen',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=h6_zOHz4Mag',
    description:
      'Bringe verschiedene Variablen auf eine gemeinsame Skala, indem du sie standardisierst oder normalisierst.',
  },
  {
    title: 'Kodierung mehrerer Antwortsets',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=gjrfSUbzpWg',
    description:
      'Diese Funktion hilft dir, multiple Antwortsets in einem Dataset zu kodieren oder zu dekodieren.',
  },
  {
    title: 'Dichotome Kodierung',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=vL_qWNB9xz4',
    description:
      'Erstelle dichotome Variablen aus qualitativen Daten für die Verwendung in logistischen Regressionen oder Entscheidungsbäumen.',
  },
  {
    title: 'Text bereinigen',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=v6EUVCS8JPw',
    description: 'Bereinige Textdaten von unnötigen Zeichen oder Fehlern.',
  },
  {
    title: 'Datensatz transponieren',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=8QvZWwAQENQ',
    description:
      'Lerne, wie du deinen Datensatz umstrukturierst, indem du Variablen in Zeilen verwandelst.',
  },
  {
    title: 'Beobachtungen sortieren',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=WCyM38qiOtA',
    description:
      'Sortiere Beobachtungen in deinem Datensatz für eine bessere Lesbarkeit oder Analyse.',
  },
  {
    title: 'Beobachtungen für die Analyse auswählen',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=17iWIxViSsc',
    description: 'Wähle gezielt Beobachtungen aus deinem Datensatz für spezifische Analysen aus.',
  },
  {
    title: 'Variablen in Beobachtungen umstrukturieren',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=u9JYEw80hok',
    description: 'Verwandle Spalten in Zeilen, um deine Daten besser zu strukturieren.',
  },
  {
    title: 'Beobachtungen in Variablen umstrukturieren',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=UOQPWx3n2Lk',
    description:
      'Verwandle Zeilen in Spalten, um eine neue Sichtweise auf deine Daten zu erhalten.',
  },
  {
    title: 'Datei in Untergruppen aufteilen',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=euanvi0NhZY',
    description:
      'Teile eine Datei in Untergruppen auf, um verschiedene Datensegmente getrennt zu analysieren.',
  },
  {
    title: 'Daten-Eigenschaften kopieren',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=h-eFACP7izc',
    description:
      'Übertrage Eigenschaften nicht nur von einer Variablen, sondern auf dein gesamtes Dataset.',
  },
  {
    title: 'Beobachtungen hinzufügen',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=Xk1DdTvMAIA',
    description: 'Füge neue Beobachtungen zu deinem Datensatz hinzu, um Datenlücken zu füllen.',
  },
  {
    title: 'Mehrfachantwortsets definieren',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=d12FaKvFMcQ',
    description: 'Definiere Mehrfachantwortsets für die bessere Handhabung von Umfragedaten.',
  },
  {
    title: 'Datenaggregation',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=W9kEcGGbCxA',
    description:
      'Lerne, wie du Aggregationen durchführst, um zusammenfassende Statistiken für Gruppen von Beobachtungen zu berechnen.',
  },
  {
    title: 'Daten aufteilen',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=xn42Sz22Cas',
    description: 'Teile Daten in kleinere Segmente für gezielte Analysen.',
  },
  {
    title: 'Fälle multiplizieren',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=6DaW3rV4OAE',
    description: 'Dupliziere Fälle in deinem Datensatz, um verschiedene Szenarien zu simulieren.',
  },
  {
    title: 'Dateien zusammenführen',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=mMlp0Xa60mk',
    description: 'Kombiniere mehrere Dateien oder Tabellen in einem einzigen Datensatz.',
  },
  {
    title: 'Konstante Variablen löschen',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=FgEsxEn9BX4',
    description:
      'Entferne Variablen, die immer denselben Wert enthalten und keine Information zur Analyse beitragen.',
  },
  {
    title: 'Doppelte Variablen löschen',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=TivoEJp0tcw',
    description: 'Bereinige deine Daten, indem du doppelte Variablen entfernst.',
  },
  {
    title: 'Dateninventur',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=jJeT63Grp5I',
    description:
      'Erstelle eine detaillierte Inventur deines Datensatzes, um ihn besser zu verstehen.',
  },
  {
    title: 'Datenbeschreibung',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=MnfvPYb4Se4',
    description:
      'Beschreibe deine Daten umfassend, um Klarheit über Struktur und Inhalt zu erhalten.',
  },
  {
    title: 'Globale Bezeichnungen erstellen',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=CLH8_FfcJCw',
    description: 'Erstelle globale Bezeichnungen für Variablen und deren Werte.',
  },
  {
    title: 'Kalender erstellen',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=aHkK8iryxI0',
    description:
      "Nutze die Funktion 'Kalender erstellen', um Datumswerte systematisch zu organisieren.",
  },
  {
    title: 'Wertbezeichnungen kopieren',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=DZbFZY0bW1M',
    description: 'Kopiere Wertebezeichnungen von einer Variable auf eine andere.',
  },
  {
    title: 'Verteilung ausgleichen',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=YCNi_C_hlVg',
    description:
      'Gleiche ungleichmäßige Datenverteilungen aus, um eine bessere Analyse zu ermöglichen.',
  },
  {
    title: 'Neues Dialogfeld erstellen',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=Q1HuSISBSEs',
    description: 'Erstelle benutzerdefinierte Dialogfelder für eine effiziente Dateneingabe.',
  },
  {
    title: 'Benutzerdefinierte Dialogfelder',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=C8eqBjrmRik',
    description: 'Nutze die Möglichkeit, eigene Dialogfelder in PS IMAGO PRO zu erstellen.',
  },
  {
    title: 'Karten-Dateien laden und bearbeiten',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=RkjSxzc7uFg',
    description: 'Lade und modifiziere Kartendateien für geografische Analysen.',
  },
  {
    title: 'Syntax-Editor',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=5etDOKwTVgw',
    description:
      'Nutze den Syntax-Editor, um komplexe Datenverarbeitungen effizient durchzuführen.',
  },
  {
    title: 'Datenorganisation in Tabellen ändern',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=SFTsRW8uD7c',
    description: 'Organisiere Daten in einer Tabelle neu, um die Übersichtlichkeit zu verbessern.',
  },
  {
    title: 'Diagramm aus Tabelle erstellen',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=Y3WLvJGCSfw',
    description: 'Erstelle Diagramme direkt aus Tabellen für eine visuelle Datenanalyse.',
  },
  {
    title: 'Diagrammvorlage erstellen',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=hfwNUh21ULk',
    description: 'Passe vorhandene Diagrammvorlagen individuell an.',
  },
  {
    title: 'Tabellen färben',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=clb5XynSXx0',
    description:
      'Hebe bestimmte Werte in Tabellen mit Farben hervor, um Muster schnell zu erkennen.',
  },
  {
    title: 'OMS-Funktion nutzen',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=b04mYeIBWzw',
    description: 'Nutze die Funktion OMS, um Datensätze automatisch zu generieren.',
  },
  {
    title: 'Tabellen formatieren',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=I_d22FYG4Mo',
    description: 'Formatiere Tabellen für eine klarere Präsentation deiner Ergebnisse.',
  },
  {
    title: 'Statistik als Fußnoten anzeigen',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=rX0rW6a-QgY',
    description: 'Zeige wichtige Statistiken als Fußnoten direkt in Tabellen an.',
  },
  {
    title: 'Ergebnisse nach PS IMAGO Designer exportieren',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=ISCcho_yToM',
    description:
      'Exportiere deine Analyseergebnisse nach PS IMAGO Designer für professionelle Berichte.',
  },
  {
    title: 'Ergebnisse als PDF exportieren',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=m3mFc7YokTs',
    description: 'Lerne, wie du Ergebnisse in das PDF-Format exportierst.',
  },
  {
    title: 'Ergebnisse in Word exportieren',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=6ykMsY-Nepc',
    description: 'Exportiere Tabellen und Diagramme zur weiteren Bearbeitung in Microsoft Word.',
  },
  {
    title: 'Ergebnisse in Excel exportieren',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=9q7EYIq73k4',
    description: 'Übertrage Ergebnisse in Excel und arbeite mit ihnen weiter.',
  },
  {
    title: 'Daten aus Textdateien importieren',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=NZlUb4uLhHQ',
    description: 'Importiere Daten aus Textdateien in PS IMAGO PRO.',
  },
  {
    title: 'Daten aus MS Excel importieren',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=JFoyQNW_LqE',
    description: 'Importiere Daten aus Microsoft Excel schnell und einfach.',
  },
  {
    title: 'Berichte veröffentlichen',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=IBrj8hhXpP8',
    description: 'Veröffentliche Berichte effizient auf verschiedenen Plattformen.',
  },
  {
    title: 'Verkaufsbericht erstellen',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=W2V0fUiaI-A',
    description: 'Erstelle standardisierte Verkaufsberichte mit PS IMAGO PRO.',
  },
  {
    title: 'Berichtsautomatisierung',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=6Y934BGc9-Q',
    description: 'Automatisiere wiederkehrende Berichte für mehr Effizienz.',
  },
  {
    title: 'Koproduktion-Analyse',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=k8JzfEpNRxo',
    description: 'Analysiere, welche Produkte häufig gemeinsam gekauft werden.',
  },
  {
    title: 'Berichtsvorlage erstellen',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=0PyLK-y0dVU',
    description: 'Erstelle anpassbare Berichtsvorlagen für deine Analysen.',
  },
  {
    title: 'Dokumentenbericht',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=zhdv09GMUN0',
    description: 'Verwalte Dokumentenberichte direkt in PS IMAGO Designer.',
  },
  {
    title: 'Single-Source-Reporting',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=Cp0NQG4gHyM',
    description: 'Kombiniere verschiedene Datenquellen in einem einzigen Bericht.',
  },
  {
    title: 'Berichtsformatierung',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=ok3eHyx4PdY',
    description: 'Formatiere deine Berichte für eine optimale Präsentation.',
  },
  {
    title: 'Bericht aufbauen',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=-YRzFw4VLyI',
    description: 'Baue einen Bericht mit allen relevanten Elementen auf.',
  },
  {
    title: 'Net Promoter Score (NPS) berechnen',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=DMSvwtvZG40',
    description: 'Berechne den Net Promoter Score (NPS) zur Kundenbindungsmessung.',
  },
  {
    title: 'Bericht aktualisieren',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=5UVPEbfHXko',
    description: 'Aktualisiere bestehende Berichte, um sie auf dem neuesten Stand zu halten.',
  },
  {
    title: 'Wasserfalldiagramm',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=UYpDmn66NRg',
    description: 'Erstelle Wasserfalldiagramme zur Darstellung kumulativer Effekte.',
  },
  {
    title: 'Violin-Plot',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=km3r2VibSnU',
    description: 'Visualisiere Verteilungen mit Violin-Plots.',
  },
  {
    title: 'Baumdiagramm',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=b7nNCNkyPIQ',
    description: 'Nutze Baumdiagramme zur Darstellung hierarchischer Strukturen.',
  },
  {
    title: 'Zusätzliche Tabellendiagramme',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=g3OKR_kFB10',
    description: 'Kombiniere Tabellen mit Diagrammen für eine erweiterte Visualisierung.',
  },
  {
    title: 'Tabellendiagramme',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=sCa79snTfDk',
    description: 'Erstelle aussagekräftige Tabellendiagramme.',
  },
  {
    title: 'Signifikante Variablen – Chi-Quadrat-Test',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=y16cuwluZMY',
    description: 'Führe einen Chi-Quadrat-Test zur Analyse signifikanter Variablen durch.',
  },
  {
    title: 'Signifikante Variablen – CHAID-Analyse',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=B7mLU2My0T8',
    description: 'Verwende die CHAID-Analyse zur Identifikation relevanter Prädiktoren.',
  },
  {
    title: 'Seriendiagramm',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=KGqLGWow09M',
    description: 'Erstelle Seriengrafiken zur Analyse von Trends über die Zeit.',
  },
  {
    title: 'Streudiagramm mit Verteilungsgraphen',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=pY7J3L9Ibko',
    description: 'Visualisiere Datenbeziehungen mit Streudiagrammen und Verteilungsgrafiken.',
  },
  {
    title: 'Beziehungsdiagramm',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=oET6RGvxj3Y',
    description: 'Nutze Beziehungsdiagramme zur Darstellung von Verbindungen zwischen Variablen.',
  },
  {
    title: 'Skalendiagramm',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=i8ZwbHm34EA',
    description: 'Verwende Skalendiagramme zur Analyse von Meinungen oder Bewertungen.',
  },
  {
    title: 'Sankey-Diagramm',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=XZGScEtvD7I',
    description: 'Visualisiere Datenflüsse mit Sankey-Diagrammen.',
  },
  {
    title: 'Ringdiagramm',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=Gcp2eX3_tSA',
    description: 'Erstelle Ringdiagramme zur Darstellung von Anteilen.',
  },
  {
    title: 'Radar-Diagramm',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=uXtXfKNo7wU',
    description: 'Nutze Radardiagramme zur Visualisierung von Skalenwerten.',
  },
  {
    title: 'Nightingale-Rosendiagramm',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=CVHfg0VMT94',
    description:
      'Das Nightingale-Rosendiagramm zeigt Veränderungen über die Zeit in einer ansprechenden grafischen Form.',
  },
  {
    title: 'Mehrdimensionales Streudiagramm',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=Dfnl6uTS474',
    description:
      'Visualisiere mehrdimensionale Datenbeziehungen mit einem erweiterten Streudiagramm.',
  },
  {
    title: 'Marimekko-Diagramm',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=_EB59BMPQF8',
    description:
      'Das Marimekko-Diagramm bietet eine alternative Visualisierung für segmentierte Daten.',
  },
  {
    title: 'Gestapeltes Balkendiagramm',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=S6X0S5vYfrs',
    description:
      'Nutze gestapelte Balkendiagramme zur Darstellung von Veränderungen innerhalb von Kategorien.',
  },
  {
    title: 'Ungleichheitsmessung',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=JrqkzOk_oCQ',
    description: 'Bewerte Einkommensungleichheiten mit der Funktion zur Ungleichheitsmessung.',
  },
  {
    title: 'Hierarchisches Diagramm',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=te93qaLY4Os',
    description: 'Erstelle hierarchische Diagramme für die Darstellung von Gruppenstrukturen.',
  },
  {
    title: 'Heatmatrix-Karte',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=rp48WsAfMRQ',
    description:
      'Nutze die Heatmatrix-Karte zur Visualisierung von aggregierten statistischen Werten.',
  },
  {
    title: 'Datenvisualisierung auf Karten',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=Y3NchBjdRn8',
    description: 'Lerne, wie du Daten geografisch auf Karten visualisierst.',
  },
  {
    title: 'Daten-Audit',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=wAcDhaaGcYU',
    description:
      'Führe ein Daten-Audit durch, um eine Zusammenfassung der wichtigsten Statistiken zu erhalten.',
  },
  {
    title: 'Dashboard Prozentsatz-Schwellenwerte',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=XauhkO-Px68',
    description: 'Erstelle Dashboards mit Prozentsatz-Schwellenwerten für eine schnelle Analyse.',
  },
  {
    title: 'Dashboard Zielerreichungs-Prozentsatz',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=l15dXwa3S_U',
    description: 'Verwende Dashboards zur Visualisierung der Zielerreichung.',
  },
  {
    title: 'Dashboard-Matrix',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=4ocZctaw0Tw',
    description: 'Erstelle eine Matrix-Dashboard-Ansicht zur Verdichtung von Informationen.',
  },
  {
    title: 'Dashboard-Zielscheibendiagramm',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=qar5EZU96aI',
    description: 'Nutze ein Dartboard-Dashboard zur intuitiven Darstellung komplexer Daten.',
  },
  {
    title: 'Dashboard-Pfeile und Ampeln',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=XUqiwmCnIrE',
    description: 'Visualisiere Ergebnisse mit Pfeilen und Ampelsymbolen in Dashboards.',
  },
  {
    title: 'Cramérs V-Korrelationsvariablen',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=YEDYPJzBdCk',
    description: 'Finde korrelierte Variablen mithilfe des Cramérs V-Koeffizienten.',
  },
  {
    title: 'Korrelationsmatrix',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=L1FmbTA0f9k',
    description:
      'Die Korrelationsmatrix zeigt Beziehungen zwischen Variablen mit Farbintensität an.',
  },
  {
    title: 'Kontingenzkarte',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=rUAtGxgE2c4',
    description: 'Die Kontingenzkarte stellt Verhältnisse zwischen zwei Variablen visuell dar.',
  },
  {
    title: 'Textvergleich',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=9P5Y22Lq1jw',
    description:
      'Vergleiche Textwerte, um Fehler oder verschiedene Schreibweisen zu identifizieren.',
  },
  {
    title: 'Clusterbewertung',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=TL9qk4LkUAQ',
    description: 'Bewerte die Qualität von Clustern in Gruppierungsanalysen.',
  },
  {
    title: 'Wortwolke',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=Mrb2evAiYOA',
    description:
      'Nutze eine Wortwolke zur ansprechenden Visualisierung von Häufigkeitsverteilungen.',
  },
];

export const featuredVideosDE: Video[] = [
  {
    videoNumber: 86,
    title: 'Nightingale-Rosendiagramm',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=CVHfg0VMT94',
    description:
      'In diesem Tutorial stellen wir dir eine interessante Möglichkeit vor, um sich über die Zeit verändernde Daten zu visualisieren. Dazu gehört z. B. die Anzahl der Arbeitslosen pro Monat oder die gesamten Ausgaben pro Quartal. Dafür nutzen wir das Nightingale-Rosendiagramm.',
  },
  {
    videoNumber: 92,
    title: 'Heatmatrix-Karte',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=rp48WsAfMRQ',
    description:
      'In diesem Tutorial werfen wir einen Blick auf eine Diagrammart, die auf einer Kreuztabelle basiert. Statt Frequenzen oder Prozentsätze anzuzeigen, kannst du hier verschiedene Statistiken wie den Mittelwert oder den Median für kategoriale Variablen visualisieren.',
  },
  {
    videoNumber: 99,
    title: 'Dashboard-Pfeile und Ampeln',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=XUqiwmCnIrE',
    description:
      'Die Visualisierung mit Pfeilen und Ampeln bietet dir umfangreiche Anpassungsmöglichkeiten für Dashboards. Sie helfen dir, die wichtigsten Analyseergebnisse übersichtlich darzustellen. In diesem Tutorial zeigen wir dir, wie du diese Funktion nutzt.',
  },
];

export const featuredVideosLandingPageDE: Video[] = [
  {
    videoNumber: 86,
    title: 'Nightingale-Rosendiagramm',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=CVHfg0VMT94',
    description: 'Zeitabhängige Entwicklungen visuell darstellen',
  },
  {
    videoNumber: 92,
    title: 'Heatmatrix-Karte',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=rp48WsAfMRQ',
    description: 'Kategorische Daten anschaulich analysieren',
  },
  {
    videoNumber: 99,
    title: 'Pfeile und Ampeln in Dashboards',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=XUqiwmCnIrE',
    description: 'Kernergebnisse übersichtlich hervorheben',
  },
];

export const allVideosEN: Video[] = [
  {
    title: 'Counting Occurrences',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=jYLq0G3I-Fw',
    description:
      'The function for counting values within observations allows you to create a variable that counts occurrences of specific values within a declared set of variables. For instance, if our dataset contains a set of variables representing readership of various weekly magazines, the Count Occurrences function can help us determine how many magazines a particular person reads.',
  },
  {
    title: 'Sorting Variables',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=nGn76s5OxcU',
    description: 'In this tutorial we will take a closer look at sorting variables.',
  },
  {
    title: 'Recoding Variables',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=Mb9zwpfEHoo',
    description: 'In this tutorial, we will show you how to use the Recoding Variables function.',
  },
  {
    title: 'Sorting and Selecting Variable Descriptions',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=c2zW7iIM8hA',
    description:
      'In this presentation, we will look at a few simple procedures that may have been somewhat forgotten by PS IMAGO PRO users but can still be very helpful, such as Sorting and Selecting Variable Descriptions.',
  },
  {
    title: 'Describing Data in the Data Editor',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=lVivjcAcZF8',
    description:
      'This presentation will demonstrate how to define variable properties using the Variable View tab in the Data Editor window.',
  },
  {
    title: 'Creating New Variables',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=A7fwVszEAf8',
    description:
      'In this tutorial, we will look at the option of calculating new values in PS IMAGO PRO. Using this function, we can perform simple mathematical transformations such as addition, multiplication, division, as well as operations on texts or date formats.',
  },
  {
    title: 'Date and Time Wizard',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=c-pxi4ijAqo',
    description: 'In this tutorial, we will explore the Date and Time calculation Wizard.',
  },
  {
    title: 'Copying Variable Properties',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=X86QGdaM1sQ',
    description:
      'Describing a dataset is a very important but unfortunately tedious task when preparing data for analysis. PS IMAGO PRO offers many functions that facilitate and speed up this process. In this tutorial, we will cover one of them.',
  },
  {
    title: 'Visual Categorization',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=xOemuIldkvI',
    description:
      'The concept of categorization or recoding involves creating categorical variables from continuous scale variables or reducing the number of categories of ordinal variables. In cases where it is difficult for an analyst to arbitrarily set division points for a variable, or where the division cannot be symmetrical due to a skewed distribution, visual categorization available in IBM SPSS Statistics can help.',
  },
  {
    title: 'Adding Variables',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=VVEohaKXzSY',
    description:
      'When preparing data for analysis, we often want to utilize information from multiple datasets and merge them into a single file. The process of merging involves combining data stored in various sources, such as files, tables, or views, into one common dataset.',
  },
  {
    title: 'Adding Comments to Variables',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=0a456Sro6bA',
    description:
      'In this tutorial, we will look at a lesser-known feature that can be very useful for those who struggle with keeping notes and often forget where they saved information. We explore User Attributes along with examples of their application. User Attributes allow you to expand the dataset with custom information for individual variables. While default attributes in the Variable View tab include Name, Type, Label, etc., user attributes allow you to add your own custom information.',
  },
  {
    title: 'Compute global labels',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=Q5kRnST6skg',
    description:
      "The procedure presented in this presentation is related to Aggregation and user attributes. Compute global values concerns variable statistics for the entire dataset, such as quarterly or yearly sales totals, which are stored in the application's cache as so-called global values and can be used for further calculations.",
  },
  {
    title: 'Automatic recode',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=wVQ6WhcHp_M',
    description:
      'In this tutorial, we will explore the function of automatic recoding for string or numeric variables into variables represented by sequential integers.',
  },
  {
    title: 'Split text',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=Z6u5krT_gwE',
    description: 'In this tutorial, we will examine a procedure called Split Text.',
  },
  {
    title: 'Recode Infrequent Categories',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=MWfl-hh9G3k',
    description:
      'In this tutorial, we will show you how to use the Recode Infrequent Categories function.',
  },
  {
    title: 'String count',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=XxArjaDIifY',
    description:
      'The String count procedure is a text analysis tool that allows you to count the occurrences of specific character strings in a selected text variable. This function is useful for analyzing responses to open-ended questions or other texts to identify the frequency of words, entire phrases, or specific character sets.',
  },
  {
    title: 'Reverse Coding',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=jYaGP7ORXKo',
    description:
      "When analyzing survey data, analysts often face the need to reverse the coding of variables. While it's possible to use the standard recoding functionality in SPSS, this process can be time-consuming, especially if there are many variables to recode. Using the Predictive Solutions Reverse Coding procedure, we can do this quickly for all variables.",
  },
  {
    title: 'Recode categories monotonically',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=gOm5hfbOPos',
    description:
      'When creating tables and charts, we often encounter the issue that the order of data on the chart is presented chaotically, usually ascending according to the value the category takes in the dataset. In this presentation, we will use the monotonic recoding procedure to reorganize the categories of a variable so that the most frequent category is displayed first, followed by the next categories in descending order.',
  },
  {
    title: 'Normalization of Variables',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=h6_zOHz4Mag',
    description:
      'During analysis, we often deal with data expressed in different values and ranges. For example, it can be challenging to analyze age and distance from residence simultaneously, especially when using them in modeling. It is essential to bring the values of these variables to a common range to make comparisons possible. This process involves normalization or standardization. Using PS IMAGO PRO, every user can now perform standardization or normalization for ordinal and quantitative variables.',
  },
  {
    title: 'Multiple response sets coding',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=gjrfSUbzpWg',
    description:
      'Multiple choice questions can be coded in a dataset in two ways – as a set of dichotomous variables or as a set of categorical variables. In this tutorial, we will use the Multiple response sets coding procedure to change the coding method from dichotomy to categories and from categories to dichotomy.',
  },
  {
    title: 'Dichotomous Coding',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=vL_qWNB9xz4',
    description:
      'To utilize logistic regression or classification trees with a qualitative variable that has more than two categories, we have to create as many zero one variables as there are categories of the variable you want to use in the analysis. In PS IMAGO PRO, this data preparation step can be done in one step using the Dichotomous Coding functionality.',
  },
  {
    title: 'Clear Text',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=v6EUVCS8JPw',
    description:
      'In this presentation we will show you how to use PS IMAGO PRO to Clear text data from redundant or incorrect information.',
  },
  {
    title: 'Transposing a Dataset',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=8QvZWwAQENQ',
    description: 'In today’s presentation, we will focus on the data transposition.',
  },
  {
    title: 'Sorting Observations',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=WCyM38qiOtA',
    description:
      'Sorting is an action used to organize data in a dataset. It is typically done for two main reasons: first, to increase efficiency, such as the speed of algorithms searching for information, or to present data in a more readable manner for the information recipient. The latter reason is predominant when working with PS IMAGO PRO',
  },
  {
    title: 'Selecting Observations for Analysis',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=17iWIxViSsc',
    description:
      "The datasets we work with daily often contain information that isn't always relevant to the analysis we intend to perform. In other words, we might need only a specific portion of data from a dataset at any given moment. The primary method for selecting observations is the Select Cases procedure found in the Data menu. This function allows several methods of observation selection based on various criteria. Additionally, it provides the option to use a random sampling algorithm for observations.",
  },
  {
    title: 'Restructuring Variables into Observations',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=u9JYEw80hok',
    description:
      'In this tutorial, we will focus on the variant that transforms variables into observations.',
  },
  {
    title: 'Restructuring Observations into Variables',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=UOQPWx3n2Lk',
    description:
      'In this presentation, we will focus on the variant that transforms observations into variables.',
  },
  {
    title: 'Split File into Subsets',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=euanvi0NhZY',
    description:
      'The "Split File" option allows you to divide a dataset into separate groups for analysis, usually based on the values of one grouping variable. In this tutorial, we will show you how to use this function.',
  },
  {
    title: 'Copying Data Properties',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=h-eFACP7izc',
    description:
      'In PS IMAGO PRO, there is a feature that allows you to transfer not only the properties of a single variable but also the entire analytical dataset. In this tutorial, we will show you how to use this function.',
  },
  {
    title: 'Adding Observations',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=Xk1DdTvMAIA',
    description: 'In this tutorial, we will show you how to use the Adding Observations function.',
  },
  {
    title: 'Defining Multiple Response Sets',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=d12FaKvFMcQ',
    description: 'In this tutorial, we will see how to use the Multiple Response Sets function.',
  },
  {
    title: 'Data Aggregation',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=W9kEcGGbCxA',
    description: 'In this tutorial, we will show you how to use the Data Aggregation function.',
  },
  {
    title: 'Split data',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=xn42Sz22Cas',
    description: 'In this tutorial, we will examine a procedure called Split data.',
  },
  {
    title: 'Multiplicate cases',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=6DaW3rV4OAE',
    description:
      'In this tutorial, we will take a look the functionality of PS IMAGO PRO called Multiplicate cases.',
  },
  {
    title: 'Join Files',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=mMlp0Xa60mk',
    description: 'In this tutorial, we will explore the procedure called Join Files.',
  },
  {
    title: 'Delete Constant variables',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=FgEsxEn9BX4',
    description:
      'In this tutorial, the functionality of a procedure that allows for the removal of constant values from a dataset will be demonstrated.',
  },
  {
    title: 'Delete Duplicate Variables',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=TivoEJp0tcw',
    description:
      'When working with data, it often becomes apparent during the cleaning process that the same information is recorded in two or more variables. As a result, redundant data needs to be removed from the dataset. Using PS IMAGO PRO, this problem can be quickly resolved with the Delete Duplicate Variables procedure.',
  },
  {
    title: 'Data inventory',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=jJeT63Grp5I',
    description:
      'In this tutorial, we will show you how to use the Data Inventory procedure available in PS IMAGO PRO.',
  },
  {
    title: 'Data Description',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=MnfvPYb4Se4',
    description:
      "In today's presentation, we will discuss the functionality of the Data Description procedure, which will help us achieve two main objectives.",
  },
  {
    title: 'Create Global Labels',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=CLH8_FfcJCw',
    description: 'In this material, we will look at the Create Global Labels procedure.',
  },
  {
    title: 'Create Calendar',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=aHkK8iryxI0',
    description:
      'The Create Calendar procedure is a tool that allows you to create a new dataset in which new observations are generated. In this tutorial, we will show you how to use this function.',
  },
  {
    title: 'Copy Value Labels',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=DZbFZY0bW1M',
    description:
      'The Copy Value Labels procedure is useful during the data preparation stage for analysis. It allows you to assign labels to variable values based on the values or labels of another variable. For example, it can be used after recoding a variable into another variable. In this tutorial, we will show you how to use this function.',
  },
  {
    title: 'Balance distribution',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=YCNi_C_hlVg',
    description: 'In this tutorial, we will show you how to use a Balance distribution function.',
  },
  {
    title: 'Create a New Dialog Box',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=Q1HuSISBSEs',
    description:
      'When working with PS IMAGO PRO, we often use the same command syntax. This is especially true for universal commands that can be applied to various data, such as creating a new dataset using the INPUT PROGRAM command or Python commands.\nIn this tutorial, we will see how to create a sample dialog box in the IBM SPSS Statistics menu, which will create a new dataset with a user-specified number of observations.',
  },
  {
    title: 'User Dialog Boxes',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=C8eqBjrmRik',
    description:
      'User dialog boxes are designed to easily customize the functionality of the program to meet individual user needs. They are particularly significant when a custom analysis, sequence of data transformations, set of charts, or reports prepared by the user is used repeatedly.',
  },
  {
    title: 'Loading and Modifying Map Files',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=RkjSxzc7uFg',
    description:
      'In this tutorial, we will demonstrate how to modify and add new maps to IBM SPSS Statistics.',
  },
  {
    title: 'Syntax Editor',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=5etDOKwTVgw',
    description:
      'In this tutorial, we will look at what the command language in IBM SPSS Statistics is through a simple example.',
  },
  {
    title: 'Changing Data Organization in a Table',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=SFTsRW8uD7c',
    description:
      'In this presentation, I will show how to manage data in a results table using PS IMAGO PRO.',
  },
  {
    title: 'Creating a Chart from a Table',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=Y3WLvJGCSfw',
    description:
      'The most commonly used methods for creating charts include the Graphs menu, options available within analytical procedures, and visualizations available in the Predictive Solutions menu. Advanced users of PS IMAGO PRO can also create custom charts using the GPL language. In this presentation, I will introduce an additional method that allows the user to create a chart without referring to the dataset.',
  },
  {
    title: 'Create a Chart Template',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=hfwNUh21ULk',
    description:
      'In this tutorial, we will show how to define a custom chart template by modifying one of the default templates.',
  },
  {
    title: 'Table Coloring',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=clb5XynSXx0',
    description:
      'When presenting data in tables, we often deal with many categories, such as university majors. The problem arises when we want to highlight the most and least attended ones. This usually involves scanning rows to find the relevant information.\nIt would be much easier if the program automatically highlighted the appropriate cells. This is exactly what the functionality presented in this tutorial does.',
  },
  {
    title: 'OMS',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=b04mYeIBWzw',
    description:
      'In this presentation, we will see how to obtain a dataset with coefficients without manual copying.',
  },
  {
    title: 'Table Formatting',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=I_d22FYG4Mo',
    description:
      'Presenting results is a key element in summarizing conducted analyses. The appearance of output objects is often determined by company standards. Today, we will see how to change the appearance of tables in PS IMAGO PRO from the default format to another predefined one, as well as how to easily create your own table appearance template.',
  },
  {
    title: 'Footnotes Statistics',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=rX0rW6a-QgY',
    description:
      'When using frequency tables, we often get two tables: one with statistics and another with the distribution of variable categories. Including both in a report can unnecessarily increase its length. But what if we could present this information in a single table? With PS IMAGO PRO, this is possible using the " Footnotes Statistics" procedure. In this tutorial, we will show you how to use this function.',
  },
  {
    title: 'Export to PS IMAGO Designer',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=ISCcho_yToM',
    description:
      'To prepare an online report using PS Imago Designer, a few steps need to be taken within PS IMAGO PRO. This presentation will guide you through the process step by step.',
  },
  {
    title: 'Exporting results to PDF',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=m3mFc7YokTs',
    description:
      'Output objects prepared in PS IMAGO PRO can be exported to various formats depending on the needs. In this presentation, I will show you how to export output objects to the popular PDF format.',
  },
  {
    title: 'Exporting results to Word',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=6ykMsY-Nepc',
    description:
      'In this tutorial, we will demonstrate how to export output objects, such as tables and charts, to the Microsoft Word text editor.',
  },
  {
    title: 'Exporting results to Excel',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=9q7EYIq73k4',
    description:
      'Output objects prepared in PS IMAGO PRO can be exported to various formats depending on the needs. In this tutorial, we will see how to easily transfer individual output objects to different sheets within a single Microsoft Excel file.',
  },
  {
    title: 'Importing Data from a Text File',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=NZlUb4uLhHQ',
    description:
      'In this tutorial, we will demonstrate how to import data from text files into PS IMAGO PRO.',
  },
  {
    title: 'Importing Data from MS Excel',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=JFoyQNW_LqE',
    description:
      'This tutorial will demonstrate how to import data from MS Excel into PS IMAGO PRO in a few simple steps.',
  },
  {
    title: 'Publishing',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=IBrj8hhXpP8',
    description:
      'The final step in preparing a report is its publication. In this presentation, we will go through the process of publishing a report on the Microsoft SharePoint platform step by step.',
  },
  {
    title: 'Sales report',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=W2V0fUiaI-A',
    description:
      'PS IMAGO PRO not only allows reporting according to company standards but also offers tools for distributing these reports to recipients and, in the case of cyclical reports, automating the entire process, providing recipients with up-to-date information.',
  },
  {
    title: 'Report automation',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=6Y934BGc9-Q',
    description:
      'One of the many advantages of PS IMAGO PRO is the ability to automate the entire process, or just selected parts of it. Today, we will show you how to prepare an automating procedure based on a previously prepared report.',
  },
  {
    title: 'Co possession',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=k8JzfEpNRxo',
    description:
      'In today’s tutorial, we will try to put ourselves in the shoes of the recipients of the analysis results. The goal set for the analyst was to prepare a report on product co-purchasing and to perform customer segmentation based on it. Co-purchasing is particularly significant in banking.',
  },
  {
    title: 'Report template',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=0PyLK-y0dVU',
    description:
      'PS IMAGO Designer is an application that allows the creation of analytical reports in the form of dashboards or traditional written reports. Working with PS IMAGO Designer begins when the user has pre-prepared tables and charts in PS IMAGO Pro.',
  },
  {
    title: 'Document Report',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=zhdv09GMUN0',
    description:
      'Working with PS IMAGO Designer at the document creation level is no different from what we know from popular text editors, except that here we have access to SPSS objects that we can edit at any time and manage from within one application.',
  },
  {
    title: 'Single source',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=Cp0NQG4gHyM',
    description:
      'In this tutorial, we will show you the function that allows you to work freely on creating reports in any format. From ad-hoc reports that summarize key information in a dashboard form to comprehensive detailed reports that thoroughly explore the subject, presenting conclusions and suggestions in a written format. Moreover, both reports can be created and managed within a single project. Regardless of the form of the report needed, you can always flexibly manage the result objects.',
  },
  {
    title: 'Report formatting',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=ok3eHyx4PdY',
    description:
      'We have reached the stage where all the objects are inserted into the report. Now, it requires formatting. We need to set the names of the individual pages, add titles, and comments to the objects. In this tutorial, we will show you how to format the report in PS IMAGO PRO.',
  },
  {
    title: 'Building report',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=-YRzFw4VLyI',
    description: 'In this tutorial, we will show you how to build a report in PS IMAGO PRO.',
  },
  {
    title: 'Net Promoter Score (NPS)',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=DMSvwtvZG40',
    description:
      'The Net Promoter Score (NPS) is a popular indicator used to measure customer loyalty. It can be calculated by asking customers one question: "On a scale from 0 to 10, how likely are you to recommend our company to a friend or colleague?"\n\nDepending on the customer\'s response, they are classified into one of three groups – brand promoters, passive customers, or brand detractors. By subtracting the percentage of detractors from the percentage of promoters, we obtain the NPS value. In this tutorial, we will show you how to use this function.',
  },
  {
    title: 'Report update',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=5UVPEbfHXko',
    description:
      'Some of our reports are prepared periodically, while others are one-time. However, as practice shows, sometimes such a report needs to be updated or supplemented. With a comprehensive solution like PS IMAGO PRO, we can significantly reduce the time needed to refresh the content. Today, we will see how to perform such an update manually.',
  },
  {
    title: 'Waterfall graph',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=UYpDmn66NRg',
    description:
      'A waterfall graph is typically used to understand the contribution of individual categories to the overall result. In this tutorial, we will show you how to use this function.',
  },
  {
    title: 'Violin plot',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=km3r2VibSnU',
    description:
      'A violin plot is an attractive and informative visualization that effectively depicts the distribution of a variable. In this tutorial, we will show you how to use this function.',
  },
  {
    title: 'Tree map',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=b7nNCNkyPIQ',
    description:
      'A tree map is used to visualize data structure through the use of area. It provides visual support for results that are typically presented in frequency tables or cross-tabulation tables. In this tutorial, we will show you how to use this function.',
  },
  {
    title: 'Additional table graphs',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=g3OKR_kFB10',
    description:
      'In this tutorial, we will explore additional Table graphs available in PS IMAGO PRO, which combine a classic table with a histogram, line chart, bar chart, or layered chart. This type of visualization is extremely useful when you want to present a large amount of information in a clear and readable form.',
  },
  {
    title: 'Table graphs',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=sCa79snTfDk',
    description:
      'In this tutorial, we will take a look at two tabular charts that offer interesting functionalities, combining the features of a classic table and a graph in one object.',
  },
  {
    title: 'Significant variables Chi square',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=y16cuwluZMY',
    description:
      'When analysing data, we are often interested in whether and what kind of relationships exist between variables. To test a hypothesis, we use the chi-square test, available in cross tabulations. In this tutorial, we will show you how to use this function.',
  },
  {
    title: 'Significant variables CHAID',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=B7mLU2My0T8',
    description:
      'When studying the significance of variables, various tests can be employed. Often, these tests require us to repeat the same steps for multiple pairs of variables. PS IMAGO PRO simplifies this process by allowing you to specify a dependent variable and a list of predictors. Unlike more traditional methods that only assess the relationship between two variables at a time, CHAID excels by examining multiple predictor variables simultaneously and revealing the most significant ones through a decision tree structure. In this tutorial, we will show you how to use this function.',
  },
  {
    title: 'Series Graph',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=KGqLGWow09M',
    description:
      'A Series graph is a type of line or layered chart that is commonly used to present a studied phenomenon over time, such as the trends of economic indicators over different years, company revenues throughout a year, or energy consumption in quarters. This chart can display counts for the main category variable or statistics of a selected quantitative variable. Additionally, it allows for segmentation by quarters or years and the inclusion of time markers to indicate the occurrence of specific events. In this tutorial, we will show you how to use this function.',
  },
  {
    title: 'Scatterplot with Distribution Graphs',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=pY7J3L9Ibko',
    description:
      'When visualizing data, an interesting effect can be achieved by using a scatter plot to present the relationship between variables such as age and income or initial and current earnings. Additionally, it can be useful to display the distributions of these variables. In this tutorial, we will show you how to use this function.',
  },
  {
    title: 'Relationship map',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=oET6RGvxj3Y',
    description:
      'A relationship map graphically presents connections between variables. It helps to get an overview of which categories interact and how often. Relationships and influences between variables are shown through nodes and connections. This visualization can be useful for identifying who plays an important role in business processes or for illustrating interactions between departments in an organization. In this tutorial, we will show you how to use this function.',
  },
  {
    title: 'Scale graph',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=i8ZwbHm34EA',
    description:
      'A scale graph is a visualization that allows presenting the intensity of attitudes towards a phenomenon measured on an ordinal scale. This type of visualization is particularly useful for scales with a neutral point, such as the Likert scale, and can be applied to both symmetric and asymmetric scales. In this tutorial, we will show you how to use this function.',
  },
  {
    title: 'Sankey Diagram',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=XZGScEtvD7I',
    description:
      'When analyzing data related to migration, transport, foreign trade, or user traffic on a website, we often face the challenge of visually representing flows between various units of analysis. The Sankey Diagram available in PS IMAGO PRO addresses this need by providing a visualization of these flows. In this tutorial, we will show you how to use this function.',
  },
  {
    title: 'Ring Chart',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=Gcp2eX3_tSA',
    description:
      'PS IMAGO Pro offers many attractive visualizations that make presenting data in a clear and appealing way easier. One such visualization is the Ring chart. In this tutorial, we will show you how to use this function.',
  },
  {
    title: 'Radar Chart',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=uXtXfKNo7wU',
    description:
      'In this tutorial, we will explore a graph that presents data in a polar format, the Radar chart. This type of chart is used to summarize scale variables on a polar coordinate system with additional lines connecting each axis.',
  },
  {
    title: 'Nightingale Rose',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=CVHfg0VMT94',
    description:
      'In this tutorial, we will introduce an interesting way to visualize data that changes over time. This can include information such as the number of unemployed people divided by months or the total expenses in a quarter. For this purpose, we will use the Nightingale Rose graph.',
  },
  {
    title: 'Multidimensional Scatterplot',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=Dfnl6uTS474',
    description:
      'In this presentation, we will explore another version of the scatter plot. Traditionally, scatter plots are often used to understand relationships between variables or to observe certain groups within the data. So far, we have been accustomed to using only two dimensions, typically represented on the X and Y axes. Now, we will demonstrate how to enhance such a plot by incorporating additional dimensions.',
  },
  {
    title: 'Marimekko Graph',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=_EB59BMPQF8',
    description:
      "In this presentation, we'll see how to create a Marimekko chart using PS IMAGO PRO, inspired by the one Finnish company's patterns. This is a specific type of bar chart where all bars have the same height, and there are no gaps between them.",
  },
  {
    title: 'Layered Bar Chart',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=S6X0S5vYfrs',
    description:
      'In this presentation, we will focus on Layered bar chart, which allows us to observe changes within the same categories.',
  },
  {
    title: 'Inequality Measures',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=JrqkzOk_oCQ',
    description:
      'Inequality Measures procedure effectively facilitates the evaluation of income inequalities over time and across different social categories, providing a detailed understanding of income distribution and concentration. In this tutorial, we will show you how to use this function.',
  },
  {
    title: 'Hierarchical graph',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=te93qaLY4Os',
    description:
      "In today's tutorial, we will look at a visualization called the hierarchical graph.\nThis type of graph allows for the presentation of data with a hierarchical structure, meaning data that can be displayed at various levels of aggregation (e.g., data for universities and their departments).",
  },
  {
    title: 'Heatmatrix Map',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=rp48WsAfMRQ',
    description:
      'In this tutorial, we will take a look at a type of chart that is based on a cross-tabulation table. However, instead of frequencies or percentages in the cells, we will present one of several statistics such as the mean or median for categorical variables.',
  },
  {
    title: 'Data Visualization on Maps',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=Y3NchBjdRn8',
    description:
      'In this presentation, we will see how data can be visualized on maps using PS IMAGO PRO. The program offers many types of map-related graphics and charts, but we will focus on two types that will help you take your first steps and build more advanced visualizations.',
  },
  {
    title: 'Data audit',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=wAcDhaaGcYU',
    description:
      'The Data Audit procedure allows for the quick preparation of a set of summary statistics, separately for quantitative and qualitative variables. In one procedure, we can select many statistics without having to calculate them using other functionalities, which can significantly speed up and simplify working with data. In this tutorial, we will show you how to use this function.',
  },
  {
    title: 'Dashboard Percentage Plan Thresholds',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=XauhkO-Px68',
    description:
      'Dashboards from the Percentage of Target Thresholds group will undoubtedly introduce a new quality to the prepared reports. Their readability, simplicity of presentation, high information content, and ease of interpretation will streamline the decision-making process and facilitate a quicker and easier assessment of the current situation. In this tutorial, we will show you how to use this function.',
  },
  {
    title: 'Dashboard Percentage of Target',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=l15dXwa3S_U',
    description:
      'Dashboards from the Percentage of Target section will undoubtedly introduce a new quality to prepared reports. Their readability, simplicity of presentation, high information content, and ease of interpretation will streamline the decision-making process and facilitate a quicker and easier assessment of the current situation. In this tutorial, we will show you how to use this function.',
  },
  {
    title: 'Dashboard Matrix',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=4ocZctaw0Tw',
    description:
      'Dashboards are designed to present as much information as possible in a simple and readable manner. In a well-prepared visualization of this type, a quick glance is enough to understand all the included information. In this presentation, we will look at a visualization called the Matrix Dashboard.',
  },
  {
    title: 'Dashboard Dartboard',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=qar5EZU96aI',
    description:
      'The Dartboard Dashboard is a great way to show complex data simply. It helps users easily see patterns and insights by using a clear, circular format with adjustable settings. In this tutorial, we will show you how to use this function.',
  },
  {
    title: 'Dashboard Arrows Traffic Lights',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=XUqiwmCnIrE',
    description:
      'The Arrows and Traffic Lights visualization offers extensive customization possibilities for the objects being prepared. They can be used in dashboards to summarize the key results of analyses. In this tutorial, we will show you how to use this function.',
  },
  {
    title: "PS IMAGO PRO – Cramer's V correlated variables",
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=YEDYPJzBdCk',
    description:
      "In this tutorial we will show you the functionality available in PS IMAGO PRO, which allows us to check which variables are correlated based on the Cramer's V coefficient.",
  },
  {
    title: 'Correlation Map',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=L1FmbTA0f9k',
    description:
      "In this tutorial, we'll explore the Correlation Map visualisation. This procedure helps display the correlation between selected variables using colour intensity. When dealing with tables with numerous variable pairs, it can be challenging to spot significant correlations or determine the strength of correlation. The Correlation Map comes in handy in these situations, also assisting in tasks such as assessing how predictors relate to each other, which is crucial for predictive modelling.",
  },
  {
    title: 'Contingency map',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=rUAtGxgE2c4',
    description:
      'PS IMAGO Pro offers many types of visualization for analysis results. One of these is the contingency map. This is a chart that presents data in a similar way to a cross-tabulation table. In this tutorial, we will show you how to use this function.',
  },
  {
    title: 'Compare text',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=9P5Y22Lq1jw',
    description:
      'Wherever we allow the possibility of manually entering values without a predefined dictionary, errors such as varied spelling interpretations, typos, or spelling mistakes can occur. Manually preparing such data is both time-consuming and prone to subjective evaluation. In situations where every typo can matter, the Compare Text procedure can be helpful. In this tutorial, we will show you how to use this function.',
  },
  {
    title: 'Cluster evaluation',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=TL9qk4LkUAQ',
    description:
      'In this tutorial, we will take a look at the Cluster Evaluation procedure, which can be used to assess the quality of observations grouping.',
  },
  {
    title: 'Cloud',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=Mrb2evAiYOA',
    description:
      'The Cloud graph is an attractive proposition for visualizing a frequency table or a table containing aggregated statistics – especially useful for variables with a large number of categories. In this tutorial, we will show you how to use this function.',
  },
];

export const featuredVideosEN: Video[] = [
  {
    videoNumber: 86,
    title: 'Nightingale Rose',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=CVHfg0VMT94',
    description:
      'In this tutorial, we will introduce an interesting way to visualize data that changes over time. This can include information such as the number of unemployed people divided by months or the total expenses in a quarter. For this purpose, we will use the Nightingale Rose graph.',
  },
  {
    videoNumber: 92,
    title: 'Heatmatrix Map',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=rp48WsAfMRQ',
    description:
      'In this tutorial, we will take a look at a type of chart that is based on a cross-tabulation table. However, instead of frequencies or percentages in the cells, we will present one of several statistics such as the mean or median for categorical variables.',
  },
  {
    videoNumber: 99,
    title: 'Dashboard Arrows Traffic Lights',
    lengthInSeconds: 0,
    link: 'https://www.youtube.com/watch?v=XUqiwmCnIrE',
    description:
      'The Arrows and Traffic Lights visualization offers extensive customization possibilities for the objects being prepared. They can be used in dashboards to summarize the key results of analyses. In this tutorial, we will show you how to use this function.',
  },
];
